import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgAuthPasswordSeeno({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M2.95 10a6.94 6.94 0 01-1.69-1.9.8.8 0 011.37-.81 6.47 6.47 0 0010.74 0 .8.8 0 011.37.82 7.05 7.05 0 01-1.96 2.08l.16.07.09.06.66.54.07.07c.19.22.24.5.14.77l-.05.1-.06.1a.74.74 0 01-.95.17l-.1-.07-.65-.53-.08-.07a.76.76 0 01-.18-.62 8.4 8.4 0 01-3.26.95c.08.1.14.23.16.37l.01.1v.95a.75.75 0 01-.53.6l-.11.03H8a.74.74 0 01-.73-.63l-.01-.1v-.95a.78.78 0 01.17-.37 8.43 8.43 0 01-3.26-.95.74.74 0 01-.19.62l-.08.07-.65.53a.74.74 0 01-1.01-1.07l.08-.08.65-.53.16-.1.09-.03-.27-.2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgAuthPasswordSeeno.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgAuthPasswordSeeno.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgAuthPasswordSeeno svgRef={ref} {...props} />
));
export default ForwardRef;
